import common from "./common.json"
import permissions from "./permissions.json"
export default {
    ...common,
    permissions,
}
